import {
  getQueryWithParams,
  getQuery,
  postMutation,
} from "src/components/ApolloConnection/ApolloProviderComponent";
import {
  LIST_DOCTOR_FEE,
  GET_DOCTOR_ID,
  GET_UPLOAD_POLICY_LINK,
  GET_UPLOADED_FILE_LINK,
} from "src/components/graphql/GraphQLquery";
import { snackbar } from "@mobiscroll/react5";

import {
  ADD_DOCTOR_FEE,
  ACTIVATE_DOCTOR_FEE,
  DEACTIVATE_DOCTOR_FEE,
} from "src/components/graphql/GraphQLmutation";

export async function getUploadPolicyLink(data) {
  try {
    let response = await getQueryWithParams(GET_UPLOAD_POLICY_LINK, data);

    if (!response || response.errors) {
      throw new Error(response?.errors?.[0]?.message || "Failed to upload file");
    }

    const result = response?.data?.uploadDoctorFeePolicy;

    // Check for error response (statusCode >= 400)
    if (result?.statusCode && result.statusCode >= 400) {
      throw new Error(result?.message || "Failed to upload file");
    }

    // Success case
    if (result?.data) {
      return result.data;
    }
    throw new Error("No upload link returned");
  } catch (error) {
    snackbar({
      message: error.message,
      color: "danger",
    });
    console.error("Error at getUploadPolicyLink:", error);
    return null;
  }
}

export async function getUploadedFileLink(data) {
  try {
    let response = await getQueryWithParams(GET_UPLOADED_FILE_LINK, data);

    if (!response || response.errors) {
      throw new Error(response?.errors?.[0]?.message || "Failed to get file link");
    }

    const result = response?.data?.getFilePresignedUrl;

    // Check for error response (statusCode >= 400)
    if (result?.statusCode && result.statusCode >= 400) {
      throw new Error(result?.message || "Failed to get file link");
    }

    // Success case
    if (result?.data) {
      return result.data;
    }
    throw new Error("No file link returned");
  } catch (error) {
    snackbar({
      message: error.message,
      color: "danger",
    });
    console.error("Error at getUploadedFileLink:", error);
    return null;
  }
}

export async function addDoctorFee(data) {
  try {
    const response = await postMutation(ADD_DOCTOR_FEE, data);

    if (!response || response.errors) {
      throw new Error(response?.errors?.[0]?.message || "Failed to add doctor fee");
    }

    const result = response?.data?.addDoctorFee;

    // Check for error response (statusCode >= 400)
    if (result?.statusCode && result.statusCode >= 400) {
      throw new Error(result?.message || "Failed to add doctor fee");
    }

    // Success case
    snackbar({
      message: result?.message || "Fee added successfully.",
      color: "success",
    });
    return true;
  } catch (e) {
    snackbar({
      message: e.message,
      color: "danger",
    });
    console.error("Error at addDoctorFee:", e);
    return false;
  }
}

export async function getDoctorId() {
  try {
    let response = await getQuery(GET_DOCTOR_ID);

    if (!response || response.errors) {
      throw new Error(response?.errors?.[0]?.message || "Failed to fetch doctor ID");
    }

    const result = response?.data?.getMyProfile;

    // Check for error response (statusCode >= 400)
    if (result?.statusCode && result.statusCode >= 400) {
      throw new Error(result?.message || "Failed to fetch doctor ID");
    }

    // Success case
    if (result?.data) {
      return result.data.id;
    }
    throw new Error("No doctor ID returned");
  } catch (error) {
    console.error("Error at getDoctorId:", error);
    return undefined;
  }
}

export async function getDoctorFees() {
  try {
    let doctorId = sessionStorage.getItem("role-id");

    if (typeof doctorId === "undefined") {
      throw new Error("Doctor ID not found");
    }

    let response = await getQueryWithParams(LIST_DOCTOR_FEE, doctorId);

    if (!response || response.errors) {
      throw new Error(response?.errors?.[0]?.message || "Failed to fetch fee list");
    }

    const result = response?.data?.listDoctorFee;

    // Check for error response (statusCode >= 400)
    if (result?.statusCode && result.statusCode >= 400) {
      throw new Error(result?.message || "Failed to fetch fee list");
    }

    // Success case
    if (result?.data && result.data.length > 0) {
      snackbar({
        message: result?.message || "Fee list fetched successfully.",
        color: "success",
      });
      return result.data;
    }
    return [];
  } catch (error) {
    snackbar({
      message: error.message,
      color: "danger",
    });
    console.error("Error at getDoctorFees:", error);
    return [];
  }
}

export async function activateDoctorFee(data) {
  try {
    const response = await postMutation(ACTIVATE_DOCTOR_FEE, data);

    if (!response || response.errors) {
      throw new Error(response?.errors?.[0]?.message || "Failed to update doctor fee");
    }

    const result = response?.data?.activateDoctorFee;

    // Check for error response (statusCode >= 400)
    if (result?.statusCode && result.statusCode >= 400) {
      throw new Error(result?.message || "Failed to update doctor fee");
    }

    // Success case
    snackbar({
      message: result?.message || "Doctor fee status updated successfully.",
      color: "success",
    });
    return true;
  } catch (e) {
    snackbar({
      message: e.message,
      color: "danger",
    });
    console.error("Error at activateDoctorFee:", e);
    return false;
  }
}

export async function deactivateDoctorFee(data) {
  try {
    const response = await postMutation(DEACTIVATE_DOCTOR_FEE, data);

    if (!response || response.errors) {
      throw new Error(response?.errors?.[0]?.message || "Failed to update doctor fee");
    }

    const result = response?.data?.deactivateDoctorFee;

    // Check for error response (statusCode >= 400)
    if (result?.statusCode && result.statusCode >= 400) {
      throw new Error(result?.message || "Failed to update doctor fee");
    }

    // Success case
    snackbar({ message: result?.message || "Doctor fee status updated successfully.", color: "success", });
    return true;
  } catch (e) {
    snackbar({
      message: e.message,
      color: "danger",
    });
    console.error("Error at activateDoctorFee:", e);
    return false;
  }
}